import { useTheme } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import LineChart from 'src/shared/components/Charts/LineChart';
import { DATASET_SOURCE_COLORS } from 'src/shared/types/charts';
import { type ChartValuesCount } from 'src/shared/types/chartsData';
import { parseLegendKeys } from '../helpers';
import { type PayrollChartData } from '../helpers/payrolls';
import TransferChart from '../TransferChart';

const mapTransfersOverTimeData = (data: PayrollChartData[]) =>
  data.reduce<{ labels: string[]; values: ChartValuesCount }>(
    (acc, values) => {
      return {
        ...acc,
        labels: [...acc.labels, values.label],
        values: {
          ...acc.values,
          extraPaymentsCount: [...acc.values.extraPaymentsCount, values.extraPaymentsTransactionCount],
          saveflowCount: [...acc.values.saveflowCount, values.saveflowTransactionsCount],
          payflowPlusProcessingCount: [
            ...acc.values.payflowPlusProcessingCount,
            values.payflowPlusProcessingTransactionCount
          ]
        }
      };
    },
    {
      labels: [],
      values: {
        payflowPlusProcessingCount: [],
        extraPaymentsCount: [],
        saveflowCount: []
      }
    }
  );

type TransfersOverTimeProps = {
  data: PayrollChartData[];
};

const TransfersOverTime = ({ data }: TransfersOverTimeProps) => {
  const { t } = useTranslation(['overview', 'common']);
  const mappedData = mapTransfersOverTimeData(data);
  const legendKeys = parseLegendKeys(mappedData.values, DATASET_SOURCE_COLORS.payflowPlusProcessingCount);

  return (
    <TransferChart
      data={mappedData.values}
      labels={mappedData.labels}
      Chart={LineChart}
      title={`${t('common:no')} ${t('of applications')}`}
      legendProps={legendKeys}
    />
  );
};

export default TransfersOverTime;
